module.exports = __webpack_public_path__ + "img/logo-menu.bd51251e.png";